import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {confirmAlert} from 'react-confirm-alert'
import styled from 'styled-components'
import {ExampleTemplate} from 'TemplateEditor/Layout/Sidebar/ExampleTemplates/ExampleTemplatesProvider'
import {Template} from 'TemplateEditor/template'
import {useTemplate} from 'TemplateEditor/TemplateProvider'

export default function ExampleTemplateItem(props: {
  exampleTemplate: ExampleTemplate
  toggleOpen: () => void
}) {
  const {t} = useI18n()
  const {exampleTemplate, toggleOpen} = props
  const {updateTemplate} = useTemplate()

  const selectTemplate = (template: Template) => {
    confirmAlert({
      message: t('templateEditor.replaceDesignConfirm'),
      closeOnClickOutside: false,
      buttons: [
        {
          label: t('common.yes'),
          onClick: () => {
            updateTemplate(exampleTemplate.template)
            toggleOpen()
          },
        },
        {
          label: t('common.no'),
          onClick: () => {},
        },
      ],
    })
  }

  return (
    <ItemHolder>
      <ItemImageHolder>
        <ItemNameHolder>{exampleTemplate.name}</ItemNameHolder>
        {exampleTemplate.image && (
          <img
            style={{width: '100%', height: 'auto', padding: '15px'}}
            src={
              process.env.PUBLIC_URL +
              `/example-templates/${exampleTemplate.image}`
            }
            alt={`example template ${exampleTemplate.name}`}
          />
        )}
      </ItemImageHolder>

      <ItemActionsHolder>
        <button
          type="button"
          className={'input__btn w-100 '}
          onClick={() => selectTemplate(exampleTemplate.template)}
        >
          {t('templateEditor.apply')}
        </button>
      </ItemActionsHolder>
    </ItemHolder>
  )
}

const ItemHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ItemNameHolder = styled.div`
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
`

const ItemImageHolder = styled.div`
  & > img {
    width: 500px;
  }
`

const ItemActionsHolder = styled.div``
